import { Component } from '@angular/core';
import { PageContainerComponent } from '@unity/layouts/page-container/page-container.component';
import { ActionSharedComponent } from '@unity/shared/composed/action-shared/action-shared.component';
import { GridCommunitySharedComponent } from '@unity/shared/grid-community-shared/grid-community-shared.component';
import { QuickActions } from '@unity/utils/quick-actions';

@Component({
  selector: 'unity-list-community-page',
  standalone: true,
  imports: [PageContainerComponent, GridCommunitySharedComponent, ActionSharedComponent],
  templateUrl: './list-community-page.component.html',
  styleUrl: './list-community-page.component.scss',
})
export class ListCommunityPageComponent {
  protected createCommunityAction = QuickActions.CreateCommunity;
  protected returnToDashboardAction = QuickActions.ReturnToDashboard;
}
